/*
 * Copyright (c) 2020, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
*/

import { Comment, Comments } from '../../data/interfaces';

export const FETCH_API_COMMENTS_REQUEST = 'FETCH_API_COMMENTS_REQUEST';
export const FETCH_API_COMMENTS_SUCCESS = 'FETCH_API_COMMENTS_SUCCESS';
export const FETCH_API_COMMENTS_FAILURE = 'FETCH_API_COMMENTS_FAILURE';

export const POST_COMMENT_REQUEST = 'POST_COMMENT_REQUEST';
export const POST_COMMENT_SUCCESS = 'POST_COMMENT_SUCCESS';
export const POST_COMMENT_FAILURE = 'POST_COMMENT_FAILURE';

export const DELETE_COMMENT_REQUEST = 'DELETE_COMMENT_REQUEST';
export const DELETE_COMMENT_SUCCESS = 'DELETE_COMMENT_SUCCESS';
export const DELETE_COMMENT_FAILURE = 'DELETE_COMMENT_FAILURE';

export const EDIT_COMMENT_SUCCESS = 'EDIT_COMMENT_SUCCESS';
export const EDIT_COMMENT_FAILURE = 'EDIT_COMMENT_FAILURE';
export const EDIT_COMMENT_REQUEST = 'EDIT_COMMENT_REQUEST';

export interface CommentActions {
    type: typeof FETCH_API_COMMENTS_REQUEST | typeof FETCH_API_COMMENTS_SUCCESS | typeof FETCH_API_COMMENTS_FAILURE
        | typeof POST_COMMENT_REQUEST | typeof POST_COMMENT_SUCCESS | typeof POST_COMMENT_FAILURE | typeof DELETE_COMMENT_REQUEST
        | typeof DELETE_COMMENT_SUCCESS | typeof DELETE_COMMENT_FAILURE
        | typeof EDIT_COMMENT_SUCCESS | typeof EDIT_COMMENT_FAILURE | typeof EDIT_COMMENT_REQUEST
    payload?: Comments | Comment | string
}
